import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/pt-br';

export default function OpenDatePicker(props) {
  const [isOpen, setIsOpen] = useState(false);

  let valor_definido = props.campo.valor.valor_definido;

  if ((valor_definido === '') || (valor_definido === null) || valor_definido === undefined) {
    valor_definido = null;
  } else {
    valor_definido = dayjs(valor_definido);
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-br"
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <DatePicker
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}

        slotProps={{
          textField: {
            onClick: () => setIsOpen(true),
            fullWidth: true,
            required: false,
            slotProps: {
              inputLabel: { shrink: true }
            },
          },
        }}

        id={props.campo.campo_variavel}
        label={props.campo.campo_nome}
        value={valor_definido}
        onChange={(valor)=>{
          setIsOpen(false);
          props.handleChange(
            props.campo.valor.valor_uuid,
            null,
            {
              target: {
                name: props.campo.campo_variavel,
                value: valor,
              }
            },
          )
        }}
      />
    </LocalizationProvider>
  );
}
